import { ModalTabPanel } from '@strava/ui/ModalWithTabs';
import React from 'react';

const FacebookTabPanel = () => {
  return <ModalTabPanel>Facebook Tab Panel</ModalTabPanel>;
};

export default FacebookTabPanel;
